// extracted by mini-css-extract-plugin
export var base = "_1u-0";
export var updateBanner = "_1u-1";